
const Access = {
    user: () => {
        if (sessionStorage.getItem('user') != null) {
            let temp = JSON.parse(sessionStorage.getItem('user'))
            return temp.username;
        }
        return null
    },
    isAdmin: (module) => {
        if (sessionStorage.getItem('access') === 'Internal' && module)
            return sessionStorage.getItem('modules').split(',').includes(module)
        return false
    },
    isInternal: () => {
        if (sessionStorage.getItem('access') === 'Internal')
            return true
        return false
    },
    setToken: (token, refreshToken) => {
        sessionStorage.setItem('token', token)
        sessionStorage.setItem('refreshToken', refreshToken)
    },
    getToken: () => {
        return sessionStorage.getItem('token')
    },
    getIdToken: () => {
        return sessionStorage.getItem('idToken')
    },
    setUser: (data) => {
        return sessionStorage.setItem('user', JSON.stringify(data))
    },
    getFullname: () => {
        let tempUser = JSON.parse(sessionStorage.getItem('user'))
        return tempUser.given_name + ' ' + tempUser.family_name
    },
    removeToken: () => {
        sessionStorage.clear();
    },
    getRefreshToken: () => {
        return sessionStorage.getItem('refreshToken');
    },
    setTokens: (name, token) => {
        sessionStorage.setItem(name, token);
    },
    hasAccess: (name) => {
        if (sessionStorage.getItem('user') != null) {
            let modules = sessionStorage.getItem('modules')
            return modules.split(',').includes(name);
        }
        return false
    },
    getUser: () => {
        if (sessionStorage.getItem('user') != null) {
            let temp = JSON.parse(sessionStorage.getItem('user'))
            return temp;
        }
        return null
    }
}

export default Access;